import { render } from "./ChatbotHeader.vue?vue&type=template&id=759f1c41&scoped=true&ts=true"
import script from "./ChatbotHeader.vue?vue&type=script&lang=ts"
export * from "./ChatbotHeader.vue?vue&type=script&lang=ts"

import "./ChatbotHeader.vue?vue&type=style&index=0&id=759f1c41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759f1c41"]])

export default __exports__